<section class="grid-1">
  <mat-card class="no-border-effect">
    <mat-card-header>
      <mat-card-title i18n="component dashboard user | titre">
        Statistiques
      </mat-card-title>
    </mat-card-header>
  </mat-card>
</section>

<header class="grid-4">
  <app-intro-card
    [icon]="'rocket_launch'"
    [content]="bots?.length ?? 0"
    i18n-title="component dashboard user - intro block | titre"
    title="Bot(s) créé(s)"
  ></app-intro-card>
  <app-intro-card
    [icon]="'troubleshoot'"
    [content]="schedulerNumber"
    i18n-title="component dashboard user - intro block | titre"
    title="analyses / semaine"
  ></app-intro-card>
  <app-intro-card
    [icon]="'bolt'"
    [content]="company?.currentData | formatFileSize"
    i18n-title="component dashboard user - intro block | titre"
    title="Données récupérées"
  ></app-intro-card>
  <app-intro-card
    [icon]="'today'"
    [content]="company?.currentTime | formatTime"
    i18n-title="component dashboard user - intro block | titre"
    title="Temps d'exécution"
  ></app-intro-card>
</header>

<section class="grid-1">
  <mat-card class="no-border-effect">
    <mat-card-header>
      <mat-card-title i18n="component dashboard user | titre">
        7 derniers jours
      </mat-card-title>
    </mat-card-header>
  </mat-card>
</section>

<section class="grid-1-2">
  <app-success-line-chart
    [data]="barChartData"
    class="grid-main"
  ></app-success-line-chart>
  <app-success-rate-card
    [successRateData]="successRateData"
    class="grid-aside"
  ></app-success-rate-card>
</section>

<section class="grid-1">
  <mat-card class="no-border-effect">
    <mat-card-header>
      <mat-card-title i18n="component dashboard user | titre">
        Robots d'exécution
      </mat-card-title>
    </mat-card-header>
  </mat-card>
</section>

@if (bots?.length === 0) {
<p class="justify-center" i18n="component dashboard user - no data">
  Aucun bot créé
</p>
} @else {
<section class="grid-3">
  @for (bot of bots; track bot) {
  <app-dashboard-bot-thumb [bot]="bot"></app-dashboard-bot-thumb>
  } @if (bots?.length % 3 !== 0) {
  <mat-card
    class="add-bot no-border-effect"
    *appHasRole="['Admin', 'Operator']"
  >
    <a
      class="add-bot-btn"
      mat-stroked-button
      color="primary"
      routerLink="/bots/new"
    >
      <mat-icon>add</mat-icon>
      <span i18n="component bot dashboard user | bouton">
        Ajouter un robot d'exécution
      </span>
    </a>
  </mat-card>
  }
</section>
}
